import { DropzoneOptions } from 'dropzone';
import { unit } from 'mathjs';

const MAX_FILE_SIZE_MiB = 80;
const FIVE_MEBIBYTES_IN_BYTES = unit('5 MiB').toNumber('bytes');
export const BulkFileUploadMessages = {
  EMPTY_FILE: 'Empty files cannot be uploaded.',
  FILE_TOO_BIG: 'This file is too big! Max file size is {{maxFilesize}}MiB.',
  FAILED_UPLOAD: 'Upload failed.',
  MAX_NUMBER_FILES_EXCEEDED:
    'Maximum number of files to be uploaded has been reached.',
} as const;

export const baseDropzoneOptions: DropzoneOptions = {
  method: 'PUT',
  uploadMultiple: false,
  chunking: true,
  forceChunking: true,
  chunkSize: FIVE_MEBIBYTES_IN_BYTES,
  parallelChunkUploads: true,
  defaultHeaders: false,
  binaryBody: true,
  autoProcessQueue: false,
  maxFilesize: MAX_FILE_SIZE_MiB,
  dictFileTooBig: BulkFileUploadMessages.FILE_TOO_BIG,
  dictResponseError: BulkFileUploadMessages.FAILED_UPLOAD,
  dictMaxFilesExceeded: BulkFileUploadMessages.MAX_NUMBER_FILES_EXCEEDED,
};
